export default __webpack_public_path__ + "static/media/SiteImageSvg.3099edba.svg";